import React from "react";
import { useCurrency } from "@/context/CurrencyContext";
import { Coins } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const fmtRate = (r) => {
  if (r == null) return "—";
  const v = Number(r);
  return v >= 1 ? v.toLocaleString("en-US", { maximumFractionDigits: 2 }) : v.toPrecision(3);
};

export default function CurrencySelector({ testId = "currency-selector" }) {
  const { currency, setCurrency, enabled, ratesDate, ratesSource, approx, rateFor } = useCurrency();
  const isApprox = (c) => approx?.includes(c);

  return (
    <Select value={currency} onValueChange={setCurrency}>
      <SelectTrigger data-testid={testId} className="w-[92px] h-10 rounded-xl">
        <Coins className="w-4 h-4 text-muted-foreground mr-1" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="w-64">
        <div className="px-2 py-2 border-b border-border mb-1" data-testid="rate-info">
          <p className="text-xs font-medium">
            {currency === "MXN" ? "Peso mexicano (base)" : (
              <span className="font-numeric">1 MXN = {fmtRate(rateFor(currency))} {currency}</span>
            )}
          </p>
          <p className="text-[11px] text-muted-foreground mt-0.5" data-testid="rate-date">
            {ratesSource || "Tasas"}{ratesDate ? ` · actualizado ${ratesDate}` : ""}
            {currency !== "MXN" && isApprox(currency) ? " · aprox." : ""}
          </p>
        </div>
        {enabled.map((c) => (
          <SelectItem key={c} value={c} data-testid={`currency-option-${c}`}>
            <span className="flex items-center justify-between gap-3 w-full">
              <span className="font-numeric">{c}</span>
              <span className="text-[11px] text-muted-foreground font-numeric">
                {c === "MXN" ? "base" : `${fmtRate(rateFor(c))}${isApprox(c) ? "≈" : ""}`}
              </span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
